import React, { useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Form,
  Button,
  Card,
  Container,
  Row,
  Col,
  Spinner,
} from "react-bootstrap";
import Swal from "sweetalert2";
import axios from "axios";

const VerifyResetOtp = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const phone = location.state?.phone || "";

  const [otp, setOtp] = useState(["", "", "", ""]);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const inputRefs = useRef([]);

  const otpCode = otp.join("");

  const handleChange = (val, idx) => {
    if (!/^[0-9]?$/.test(val)) return;
    const newOtp = [...otp];
    newOtp[idx] = val;
    setOtp(newOtp);
    if (val && idx < 3) inputRefs.current[idx + 1].focus();
  };

  const handleVerifyAndReset = async (e) => {
    e.preventDefault();

    if (otpCode.length < 4)
      return Swal.fire("Error", "Masukkan kode OTP 4 digit.", "warning");
    if (newPassword !== confirmPassword)
      return Swal.fire("Error", "Konfirmasi password tidak cocok.", "error");

    setLoading(true);
    try {
      const verifyRes = await axios.post(
        `${process.env.REACT_APP_APP_URL}/forgot-password/verify`,
        { phone_number: phone, otp: otpCode },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Platform": process.env.REACT_APP_X_PLATFORM,
            "API-Key": process.env.REACT_APP_API_KEY,
            "X-API-Version": process.env.REACT_APP_X_API_VERSION,
          },
        },
      );

      const { user_id, reset_token } = verifyRes.data.data;

      await axios.post(
        `${process.env.REACT_APP_APP_URL}/forgot-password/reset`,
        {
          user_id,
          reset_token,
          new_password: newPassword,
          new_password_confirmation: confirmPassword,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Platform": process.env.REACT_APP_X_PLATFORM,
            "API-Key": process.env.REACT_APP_API_KEY,
            "X-API-Version": process.env.REACT_APP_X_API_VERSION,
          },
        },
      );

      Swal.fire({
        icon: "success",
        title: "Password Berhasil Diubah",
        text: "Silakan login kembali.",
      }).then(() => navigate("/login"));
    } catch (err) {
      const msg =
        err.response?.data?.message || "Gagal verifikasi atau reset password.";
      Swal.fire("Gagal", msg, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="d-flex justify-content-center align-items-center vh-100">
      <Card
        className="p-4 shadow-lg"
        style={{ width: "100%", maxWidth: "400px" }}
      >
        <h4 className="text-center mb-3">Verifikasi OTP</h4>
        <p className="text-center text-muted">
          Masukkan kode OTP yang dikirim ke <strong>{phone}</strong>
        </p>

        <Form onSubmit={handleVerifyAndReset}>
          <Row className="justify-content-center mb-3">
            {otp.map((digit, idx) => (
              <Col key={idx} xs={3} className="px-1">
                <Form.Control
                  type="text"
                  maxLength={1}
                  value={digit}
                  onChange={(e) => handleChange(e.target.value, idx)}
                  ref={(el) => (inputRefs.current[idx] = el)}
                  className="text-center fs-4"
                />
              </Col>
            ))}
          </Row>

          <Form.Group className="mb-3">
            <Form.Label>Password Baru</Form.Label>
            <Form.Control
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Konfirmasi Password</Form.Label>
            <Form.Control
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
          </Form.Group>

          <Button
            type="submit"
            variant="primary"
            className="w-100"
            disabled={loading}
          >
            {loading ? (
              <Spinner animation="border" size="sm" />
            ) : (
              "Verifikasi & Ubah Password"
            )}
          </Button>

          <Button
            variant="link"
            className="w-100 mt-2"
            onClick={() => navigate("/forgot-password")}
          >
            Kembali
          </Button>
        </Form>
      </Card>
    </Container>
  );
};

export default VerifyResetOtp;
